import t from"../../../node_modules/styled-components/dist/styled-components.esm.js";import{defaultTheme as e}from"../../../theme/index.js";const o=t.h3`
  ${e.theme.mixin.fontSubtitleXXS};
  margin: 0 auto;
  text-align: center;
  font-family: ${e.theme.mainFont};
  color: ${e.theme.colorVariables.textDark};
`;o.defaultProps=e;export{o as Title};
